export default function ArticlesExplore() {
  return (
    <div>
      <div>ExploreArticles</div>
      <p>react rooter test</p>
    </div>
  );
}
